// Float32 → IEEE 754 binary16 bits (round to nearest even), table-driven (van der Zijp).
const baseTable = new Uint16Array(512);
const shiftTable = new Uint8Array(512);
for (let i = 0; i < 256; i++) {
  const e = i - 127;
  if (e < -24) {
    baseTable[i] = 0x0000;
    baseTable[i | 0x100] = 0x8000;
    shiftTable[i] = shiftTable[i | 0x100] = 24;
  } else if (e < -14) {
    baseTable[i] = 0x0400 >> (-e - 14);
    baseTable[i | 0x100] = (0x0400 >> (-e - 14)) | 0x8000;
    shiftTable[i] = shiftTable[i | 0x100] = -e - 1;
  } else if (e <= 15) {
    baseTable[i] = (e + 15) << 10;
    baseTable[i | 0x100] = ((e + 15) << 10) | 0x8000;
    shiftTable[i] = shiftTable[i | 0x100] = 13;
  } else if (e < 128) {
    baseTable[i] = 0x7c00;
    baseTable[i | 0x100] = 0xfc00;
    shiftTable[i] = shiftTable[i | 0x100] = 24;
  } else {
    baseTable[i] = 0x7c00;
    baseTable[i | 0x100] = 0xfc00;
    shiftTable[i] = shiftTable[i | 0x100] = 13;
  }
}
const f32 = new Float32Array(1);
const u32 = new Uint32Array(f32.buffer);

export function toHalf(v: number): number {
  f32[0] = v;
  const f = u32[0]!;
  const e = (f >>> 23) & 0x1ff;
  return baseTable[e]! + ((f & 0x007fffff) >>> shiftTable[e]!);
}

export function halfToFloat(h: number): number {
  const s = h & 0x8000 ? -1 : 1;
  const e = (h >>> 10) & 0x1f;
  const m = h & 0x3ff;
  if (e === 0) return s * m * 2 ** -24;
  if (e === 31) return m ? NaN : s * Infinity;
  return s * (1 + m / 1024) * 2 ** (e - 15);
}

/** Converts a whole Float32Array to half-float bits. */
export function toHalfArray(src: Float32Array, out = new Uint16Array(src.length)): Uint16Array {
  for (let i = 0; i < src.length; i++) out[i] = toHalf(src[i]!);
  return out;
}
